export const env = {
  gtm: process.env.REACT_APP_GTM as string,
  joinUrl: process.env.REACT_APP_JOIN_URL as string,
};
